import { render, staticRenderFns } from "./Scadmin.vue?vue&type=template&id=952dac7e&scoped=true"
import script from "./Scadmin.vue?vue&type=script&lang=js"
export * from "./Scadmin.vue?vue&type=script&lang=js"
import style0 from "./Scadmin.vue?vue&type=style&index=0&id=952dac7e&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952dac7e",
  null
  
)

export default component.exports